<template>
    <BreadCrumb PageTitle="Ajouter un modèle de contrat" />
    <AddModelContrat />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
      import AddModelContrat from "@/components/ModelContrat/AddModelContrat.vue";
  
    export default defineComponent({
      name: "ModelContratPage",
      components: {
        BreadCrumb,
        AddModelContrat,
      },
    });
  </script>